export default __webpack_public_path__ + "static/media/robot-hoop-throw.336deab0.webp";